import { render, staticRenderFns } from "./r-pagination.vue?vue&type=template&id=60098b6e"
import script from "./r-pagination.vue?vue&type=script&lang=js"
export * from "./r-pagination.vue?vue&type=script&lang=js"
import style0 from "./r-pagination.vue?vue&type=style&index=0&id=60098b6e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports